const typography = {
  sans: ["Source Sans Pro", "sans-serif"],
};

export default typography;
